import { render, staticRenderFns } from "./VuesticPageNotFoundCustom.vue?vue&type=template&id=662bc704"
import script from "./VuesticPageNotFoundCustom.vue?vue&type=script&lang=js"
export * from "./VuesticPageNotFoundCustom.vue?vue&type=script&lang=js"
import style0 from "./VuesticPageNotFoundCustom.vue?vue&type=style&index=0&id=662bc704&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports